import { makeStyles } from '@material-ui/core/styles';

/**
 * MUI Custom style for filters (gérer mes salariés, etc.)
 */
export const useCustomStyles = makeStyles((theme) => ({
    btnBlue: {
        display: 'flex',
        height: '54px',
        paddingLeft: '20px',
        paddingRight: '20px',
        alignItems: 'center',
        gap: '8px',
        flexShrink: 0,
        borderRadius: '5px',
        border: `2px solid ${theme.palette.primary.main}`,
        background: '#fff',
        color: theme.palette.primary.main,
        textAlign: 'center',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '78.24px',
        '&:hover': {
            color: '#fff',
            backgroundColor: theme.palette.primary.main,
        },
        '&:disabled': {
            backgroundColor: '#ccc', // Use your desired gray color
            color: '#999', // Use your desired text color for disabled state
            border: '2px solid #ccc', // Use your desired border color for disabled state
            pointerEvents: 'none', // Prevent interactions when the button is disabled
        },
    },
    btnRed: {
        display: 'flex',
        height: '54px',
        paddingLeft: '20px',
        paddingRight: '20px',
        alignItems: 'center',
        gap: '8px',
        flexShrink: 0,
        borderRadius: '5px',
        border: `2px solid ${theme.palette.error.main}`, // Use error color from theme
        background: '#fff',
        color: theme.palette.error.main, // Use error color from theme
        textAlign: 'center',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '78.24px',
        '&:hover': {
            color: '#fff',
            backgroundColor: theme.palette.error.main, // Use error color from theme
        },
        '&:disabled': {
            backgroundColor: '#ccc', // Use your desired gray color
            color: '#999', // Use your desired text color for disabled state
            border: '2px solid #ccc', // Use your desired border color for disabled state
            pointerEvents: 'none', // Prevent interactions when the button is disabled
        },
    },
    txtRedLight: {
        color: '#eb4c37',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    txtRedLightBold: {
        color: '#eb4c37',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1.1 rem',
    },
    txtRedDark: {
        color: '#eb4c37',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    txtRedDarkBold: {
        color: '#eb4c37',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
    },

    txtBlueLight: {
        color: '#4f7793',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    txtBlueLightBold: {
        color: '#4f7793',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1.1 rem',
    },
    txtBlueDark: {
        color: theme.palette.primary.main,
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    txtBlueDarkBold: {
        color: theme.palette.primary.main,
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
    },

    txtGrayLight: {
        color: '#969797 ',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    txtGrayLightBold: {
        color: '#969797 ',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
    },
    txtGrayDark: {
        color: '#4c5155',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    txtGrayDarkBold: {
        color: '#4c5155',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
    },
    txtGreenDark: {
        color: '#18964b',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    txtGreenDarkBold: {
        color: '#18964b',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
    },
    txtBlack: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    txtBlackBold: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
    },
    icon: {
        width: '35px',
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5px 10px',
        fontSize: '30px',
    },
    iconText: {
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    // Select
    select: {
        color: '#3d454c',
        paddingLeft: '10px',
        fontFamily: ['Open Sans', 'sans-serif'].join(),
    },
    // Input
    root: {
        fontFamily: ['Open Sans', 'sans-serif'].join(),
        // '& .MuiFormLabel-root': {
        //     color: '#8f8f8f',
        //     fontSize: 22,
        //     fontFamily: 'Muli',
        //     transform: 'none',
        //     top: 17,
        //     left: 13,
        // },
        // '& .MuiFormLabel-root.Mui-error': {
        //     color: '#b04995',
        // },
        '& input': {
            color: '#3d454c',
            fontFamily: ['Open Sans', 'sans-serif'].join(),
            // fontSize: 14,
            fontWeight: 300,
            // padding: '26px 12px 0',
            // transition: 'padding 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        },
        // '& .MuiFormLabel-filled + .MuiInputBase-root input': {
        //     padding: '35px 12px 14px',
        // },
        // '& .Mui-focused input': {
        //     padding: '35px 12px 14px',
        // },
        // '& .MuiFormHelperText-root.Mui-error': {
        //     color: '#b04995',
        //     fontFamily: 'Muli',
        //     fontSize: 12,
        // },
    },
}));
